import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import UserAgentMixin from '@/helpers/mixins/UserAgentMixin';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let SalesPartnerGetStarted = class SalesPartnerGetStarted extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin, UserAgentMixin) {
    get benefits() {
        return [
            {
                title: 'Get 10% of all collected convenience fees from referred merchants',
                description: `We'll send you accumulated commission fees from billing payments of your merchants.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/sales-partner-benefit-1.png`,
                    height: this.mdAndUp ? 360 : 320,
                },
            },
            {
                title: 'Early access to new features',
                description: `To provide enormous value to your merchants, we'll share with you features 
                      that we are in planning to launch so that you upsell them to your merchants.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/sales-partner-benefit-2.png`,
                    height: this.mdAndUp ? 460 : 320,
                },
            },
            {
                title: 'Priority Support',
                description: `As our official partner, you can share us your concerns that are affecting your 
                      valued merchants.`,
                img: {
                    src: `${S3_ASSETS_BUCKET_URL}/sales-partner-benefit-3.svg`,
                    height: this.mdAndUp ? 317 : 217,
                },
            },
        ];
    }
    heroBanner() {
        const src = `${S3_ASSETS_BUCKET_URL}/sales-partner-get-started-hero-banner.svg`;
        if (this.mdAndUp) {
            return { src, height: 670 };
        }
        return { src, height: 270 };
    }
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
    goToResellerLogin() {
        const { origin } = window.location;
        this.goToSignIn(`${origin}/login/reseller`);
    }
};
SalesPartnerGetStarted = __decorate([
    Component({
        components: {
            TheFooter,
            GetStarted,
        },
    })
], SalesPartnerGetStarted);
export default SalesPartnerGetStarted;
